import {
    FETCH_PUBLIC_TEMPLATES_START,
    FETCH_PUBLIC_TEMPLATES_SUCCESS,
    FETCH_PUBLIC_TEMPLATES_ERROR,
    ADD_UPDATE_PUBLIC_TEMPLATE_START,
    ADD_UPDATE_PUBLIC_TEMPLATE_SUCCESS,
    ADD_UPDATE_PUBLIC_TEMPLATE_ERROR,
    DELETE_PUBLIC_TEMPLATE_START,
    DELETE_PUBLIC_TEMPLATE_SUCCESS,
    DELETE_PUBLIC_TEMPLATE_ERROR,
    HIDE_TEMPLATE_INFO_MODAL,
    SHOW_TEMPLATE_INFO_MODAL,
  
} from '../../actions/guildlibrarian/publicTemplatesAction';

const INIT_STATE = {
    loading: false,
    submitting: false,
    error: '',
    message: '',
    showModal: false,
    publicTemplates: {},
};

const publicTemplatesReducer = (state = INIT_STATE, action) => {
    let newPublicTemplates;
    let firstNode;
    let secondNode;
    let index;
    switch (action.type) {
        case FETCH_PUBLIC_TEMPLATES_START: {
            return { ...state, error: '', message: '', loading: true };
        }
        case FETCH_PUBLIC_TEMPLATES_SUCCESS: {
            return { ...state, loading: false, publicTemplates: action.publicTemplates };
        }
        case FETCH_PUBLIC_TEMPLATES_ERROR: {
            return { ...state, loading: false, error: action.error };
        }
        case SHOW_TEMPLATE_INFO_MODAL: {
            return { ...state, loading: false, showModal: true };
        }
        case HIDE_TEMPLATE_INFO_MODAL: {
            return { ...state, loading: false, showModal: false };
        }
        case ADD_UPDATE_PUBLIC_TEMPLATE_START: {
            return { ...state, loading: false, submitting: true };
        }
        case ADD_UPDATE_PUBLIC_TEMPLATE_SUCCESS: {
            newPublicTemplates = { ...state.publicTemplates };
            firstNode = { ...newPublicTemplates[action.template.directory1] };
            if (Object.keys(firstNode).length === 0) {
                firstNode[action.template.directory2] = [{...action.template}];
                newPublicTemplates[action.template.directory1] = { ...firstNode };
            } else {
                secondNode = firstNode[action.template.directory2] ? [...firstNode[action.template.directory2]] : [];
                if (secondNode.length === 0) {
                    firstNode[action.template.directory2] =  [{...action.template}];
                    newPublicTemplates[action.template.directory1] = { ...firstNode };
                } else {
                    index = secondNode.findIndex(node => node.id === action.template.id && node.name === action.template.name);
                    if (index > -1) {
                        secondNode.splice(index, 1, action.template);
                    }else{
                        secondNode.push(action.template);
                    }
                    firstNode[action.template.directory2] = [...secondNode];
                    newPublicTemplates[action.template.directory1] = { ...firstNode };
                }
            }
            return { ...state, loading: false, submitting: false, showModal: false,  publicTemplates: { ...newPublicTemplates } };
        }
        case ADD_UPDATE_PUBLIC_TEMPLATE_ERROR: {
            return { ...state, loading: false, submitting: false };
        }
        case DELETE_PUBLIC_TEMPLATE_START: {
            return { ...state, loading: false, submitting: true };
        }
        case DELETE_PUBLIC_TEMPLATE_SUCCESS: {
            newPublicTemplates = { ...state.publicTemplates };
            firstNode = { ...newPublicTemplates[action.template.directory1] };
            if(Object.keys(firstNode).length > 0){
                secondNode = firstNode[action.template.directory2] ? [...firstNode[action.template.directory2]] : [];
                if(secondNode.length > 0){
                    index = secondNode.findIndex(node => node.id === action.template.id && node.name === action.template.name);
                    if (index > -1) {
                        secondNode.splice(index, 1);
                        firstNode[action.template.directory2] = [...secondNode];
                        newPublicTemplates[action.template.directory1] = { ...firstNode };
                    }
                }
            }
            return { ...state, loading: false, submitting: false, publicTemplates: { ...newPublicTemplates } };
        }
        case DELETE_PUBLIC_TEMPLATE_ERROR: {
            return { ...state, loading: false, submitting: false };
        }
        default:
            return state;
    }
}

export default publicTemplatesReducer;
